import { BROADCAST_SET_SCENES_WITH_SOURCE } from 'actions/Types';

export default (state = [], action) => {
  if (action.type === BROADCAST_SET_SCENES_WITH_SOURCE) return action.payload;

  return state;
};
